import React from 'react'

import { Dialog, FlatButton, Toggle, Divider, MenuItem, DropDownMenu, RadioButtonGroup, RadioButton } from 'material-ui'

import MemberRemovalDialog from './MemberRemovalDialog'
import MemberDataValidationDialog from './MemberDataValidationDialog'
import { PhoneNumberUtils } from '@fibo-app/fibo-collab-shared'

import closeIcon from 'resources/close_icon.png'

const MemberCardHeader = ({ displayMode, onCloseClicked }) => {
  return (
    <div style={styles.header}>
      <div style={styles.headingStyles}>
        {`${displayMode.ActionType} Member`}
      </div>
      <img src={closeIcon} title='Close' width={16}
        onClick={onCloseClicked}
        style={{ cursor: 'pointer' }} />
    </div>
  )
}

const MemberCardBody = ({ member, allowPhoneNumberEdits, showSettings, disableEdits, disableAdminSwitch, onMemberFieldUpdated }) => {
  return (
    <div style={styles.bodyContainerStyles}>
      <div style={styles.bodyStyles}>
        <div style={styles.generalContainerStyles}>
          <div style={styles.modulesHedingStyles}>General</div>
          <div style={styles.modulesContainerStyles}>
            {/* Here comes modules plugging. Fixed now to show Fullname, Nickname and Phone number */}
            <div style={styles.moduleContainerStyles}>
              <div style={styles.moduleLabelStyles}>
                Full name
              </div>
              <div style={styles.moduleInputStyles}>
                <input style={textInputStyles(disableEdits)}
                  disabled={disableEdits}
                  value={member.fullName || ''}
                  onChange={(e) => onMemberFieldUpdated('fullName', e.target.value)} />
              </div>
            </div>

            <div style={styles.moduleContainerStyles}>
              <div style={styles.moduleLabelStyles}>
                Display name
              </div>
              <div style={styles.moduleInputStyles}>
                <input style={textInputStyles(disableEdits)}
                  disabled={disableEdits}                  
                  value={member.displayName || ''}
                  onChange={(e) => onMemberFieldUpdated('displayName', e.target.value)}/>
              </div>
            </div>

            <div style={styles.moduleContainerStyles}>
              <div style={styles.moduleLabelStyles}>
                Role
              </div>
              <div style={styles.moduleInputStyles}>
                <input style={textInputStyles(disableEdits)}
                  disabled={disableEdits}                  
                  value={member.role || ''}
                  onChange={(e) => onMemberFieldUpdated('role', e.target.value)} />
              </div>
            </div>

            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
              <div style={styles.moduleContainerStyles}>
                <div style={styles.moduleLabelStyles}>
                  Country code
                </div>
                <div style={styles.moduleInputStyles}>
                  <DropDownMenu
                    style={{height: 32}}
                    underlineStyle={{border: 0}}
                    iconStyle={{padding: 0, height: 32}}
                    selectedMenuItemStyle={{color: 'black'}}
                    labelStyle={{...dropDownStyles(!allowPhoneNumberEdits), height: 32, lineHeight: '32px'}}
                    value={member.countryCode}
                    disabled={!allowPhoneNumberEdits}
                    onChange={(event, index, countryCode) => onMemberFieldUpdated('countryCode', countryCode)}>
                    {
                      PhoneNumberUtils.areaCodeList.map((value, idx) =>
                        <MenuItem
                          key={idx}
                          value={value.code}
                          label={value.code}
                          primaryText={`${value.name} (${value.code})`}/>
                      )
                    }
                  </DropDownMenu>
                </div>
              </div>

              <div style={styles.moduleContainerStyles}>
                <div style={styles.moduleLabelStyles}>
                  Phone number
                </div>
                <div style={styles.moduleInputStyles}>
                  <input disabled={!allowPhoneNumberEdits}
                    style={textInputStyles(!allowPhoneNumberEdits)}
                    value={member.number || ''}
                    onChange={(e) => onMemberFieldUpdated('number', e.target.value)} />
                </div>
              </div>
            </div>

            <div style={styles.moduleContainerStyles}>
              <div style={styles.moduleLabelStyles}>
                Email (optional)
              </div>
              <div style={styles.moduleInputStyles}>
                <input style={textInputStyles(disableEdits, 200)}
                  disabled={disableEdits}                  
                  value={member.email || ''}
                  onChange={(e) => onMemberFieldUpdated('email', e.target.value)} />
              </div>
            </div>
          </div>
        </div>

        { /* Show settings if there is at least one module activated. TODO after modules integration in teams. */
          showSettings &&
          <div>
            <Divider style={{ marginTop: 4, marginBottom: 16 }}/>

            <div style={styles.settingsContainerStyles}>
              <div style={styles.modulesHedingStyles}>Settings</div>
              <div style={styles.modulesContainerStyles}>
                {/* Here comes modules plugging. Fixed now to show only the admin setting */}
                <div style={styles.moduleContainerStyles}>
                  <div style={styles.moduleInputStyles}>
                    <RadioButtonGroup style={styles.radioButtonGroup}
                      name='access' valueSelected={member.access}
                      onChange={(event, value) => onMemberFieldUpdated('access', value)}>
                      <RadioButton
                        value='admin'
                        label='Admin'
                        disabled={disableAdminSwitch}
                        iconStyle={styles.radioIcon}
                        style={styles.radioButton} />
                      <RadioButton
                        value='manager'
                        label='Manager'
                        disabled={disableAdminSwitch}
                        iconStyle={styles.radioIcon}
                        style={styles.radioButton} />
                      <RadioButton
                        value='member'
                        label='Member'
                        disabled={disableAdminSwitch}
                        iconStyle={styles.radioIcon}
                        style={styles.radioButton} />
                    </RadioButtonGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

const MemberCardFooter = ({ displayMode, showActionComplete, showActionCancel,
  onActionCompleted, onActionCanceled }) => {
  const buttons = []
  if (showActionCancel) {
    buttons.push(
      <FlatButton
        key={'Cancel'}
        style={styles.cancelActionStyles}
        labelStyle={styles.cancelActionLabelStyles}
        label={displayMode.ActionCancel}
        onTouchTap={onActionCanceled} />)
  }
  if (showActionComplete) {
    buttons.push(
      <FlatButton
        key={'Complete'}
        style={styles.completeActionStyles}
        label={displayMode.ActionComplete}
        labelStyle={styles.completeActionLabelStyles}
        onTouchTap={onActionCompleted} />)
  }
  return (
    <div style={styles.footerStyles}>
      {buttons}
    </div>
  )
}

class MemberCard extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showCancelConfirmation: false,
      validationError: null
    }
  }

  handleMemberFieldUpdated = (fieldName, value) => {
    this.props.editor.updateMemberField(fieldName, value)
    this.forceUpdate()
  }

  handleMemberDataValidationDialogCloseRequest = () => {
    this.setState({
      validationError: null
    })
  }

  onActionCanceled = () => {
    /**
     * Show removal confirmation dialog and then call cancelActionConfirmation
     * TODO
     * this.setState({ showCancelConfirmation: true })
     */
    this.props.onActionCanceled()
  }

  onCancelActionConfirmed = () => {
    this.props.editor.cancelAction()
    this.props.onActionCanceled()
  }

  onActionCompleted = () => {
    const validationResult = this.props.editor.validate()
    if (validationResult.success) {
      this.props.editor.completeAction()
      this.props.onActionCompleted()
    }
    else {
      this.setState({
        validationError: validationResult.error
      })
    }
  }

  render() {
    const editor = this.props.editor
    const displayMode = editor ? editor.getDisplayMode() : {}
    const member = editor ? editor.getMember() : {}
    const allowPhoneNumberEdits = editor ? editor.allowPhoneNumberEdits() : false
    const showSettings = editor ? editor.showSettings() : false
    const disableEdits = editor ? editor.disableEdits() : false
    const disableAdminSwitch = editor ? editor.disableAdminSwitch() : false
    const showComplete = editor ? editor.showActionCompleteButton() : false
    const showCancel = editor ? editor.showActionCancelButton() : false
    return (
      <div style={styles.dialogContainerStyles}>
        <Dialog open={editor !== null} onRequestClose={this.props.onDialogClosed}
          bodyStyle={styles.dialogBodyStyles}
          contentStyle={styles.dialogContainerStyles}>
          <MemberCardHeader displayMode={displayMode}
            onCloseClicked={this.props.onActionCanceled} />
          <MemberCardBody
            member={member}
            allowPhoneNumberEdits={allowPhoneNumberEdits}
            showSettings={showSettings}
            disableEdits={disableEdits}
            disableAdminSwitch={disableAdminSwitch}
            onMemberFieldUpdated={this.handleMemberFieldUpdated}/>
          <MemberCardFooter
            displayMode={displayMode}
            showActionComplete={showComplete}
            showActionCancel={showCancel}
            onActionCompleted={this.onActionCompleted}
            onActionCanceled={this.onActionCanceled} />
        </Dialog>
        <MemberRemovalDialog
          open={this.state.showCancelConfirmation}
          onActionConfirmed={this.onCancelActionConfirmed} />
        <MemberDataValidationDialog
          open={this.state.validationError !== null}
          error={this.state.validationError}
          onCloseRequest={this.handleMemberDataValidationDialogCloseRequest} />
      </div>
    )
  }

}

const textInputStyles = (disableEdits, width) => ({
  border: 'solid 1px rgba(0, 0, 0, 0.12)',
  borderRadius: 3,
  backgroundColor: disableEdits ? 'rgba(0,0,0,0.12)' : '#fefefe',
  padding: '7px 3px 7px 11px',
  color: '#757575',
  fontSize: 14,
  width: width || null
})

const dropDownStyles = (disableEdits) => ({
  border: 'solid 1px rgba(0, 0, 0, 0.12)',
  color: '#757575',
  backgroundColor: disableEdits ? 'rgba(0,0,0,0.12)' : '#fefefe',
  fontSize: 14
})

const styles = {
  dialogContainerStyles: {
    borderRadius: '6px',
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto'
  },
  dialogBodyStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: '6px'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '30px 24px'
  },
  headingStyles: {
    fontSize: 16,
    color: '#212121'
  },
  headerCloseStyles: {
    color: '#757575',
    fontSize: 20,
    transform: 'rotate(45deg)',
    cursor: 'pointer'
  },
  footerStyles: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '20px 16px'
  },
  cancelActionStyles: {
    borderRadius: 3,
    marginRight: 16,
    backgroundColor: '#f7f7f7',
    border: 'solid 1px rgba(0, 0, 0, 0.2)'
  },
  cancelActionLabelStyles: {
    color: 'rgba(0, 0, 0, 0.55)',
    fontSize: 14
  },
  completeActionStyles: {
    borderRadius: 3,
    backgroundColor: '#356992'
  },
  completeActionLabelStyles: {
    color: 'white',
    fontSize: 14
  },
  bodyContainerStyles: {
    backgroundColor: '#f1f1f1',
    padding: 16,
    overflow: 'auto'
  },
  bodyStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 60px 40px 60px',
    backgroundColor: 'white',
    borderRadius: 6
  },
  generalContainerStyles: {
    display: 'flex',
    flexDirection: 'column'
  },
  settingsContainerStyles: {
    display: 'flex',
    flexDirection: 'column'
  },
  modulesContainerStyles: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  },
  modulesHedingStyles: {
    color: '#212121',
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 20
  },
  moduleLabelStyles: {
    fontSize: 14,
    fontWeight: 500,
    color: '#757575',
    marginBottom: 7
  },
  moduleContainerStyles: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 12
  },
  moduleInputStyles: {
    marginRight: 18,
    height: 32
  },
  radioButtonGroup: {
    display: 'flex'
  },
  radioButton: {
    width: null,
    marginRight: 24
  },
  radioIcon: {
    marginRight: 8
  }
}

export default MemberCard



// WEBPACK FOOTER //
// ./src/team/MemberCard.js